import { useQuery } from '@tanstack/react-query';
import { buscarPreviaPropostaLead, type PreviaDoLead } from '@/lib/previaPropostaApi';

/** A proposta pronta do TOP do lead (Portabilidade, TT, Renovação, Oi, Algar — só CNPJ). */
export function usePreviaPropostaLead(leadId: string | null | undefined, ativo = true) {
  return useQuery({
    queryKey: ['previa-proposta-lead', leadId],
    enabled: !!leadId && ativo,
    staleTime: 5 * 60_000,
    queryFn: (): Promise<PreviaDoLead | null> => buscarPreviaPropostaLead(leadId as string),
  });
}
